import { default as couponService } from "@/components/form-fields/CouponField/services/coupons";

import { ContractDisplayTypes } from "../../../Contracts/types/contracts";
import { CouponAssociation } from "../types/coupons";

export interface UseCouponProps {
  association: CouponAssociation;
  type: ContractDisplayTypes;
}

const useCoupon = ({
  association,
  type,
}: UseCouponProps) => {

  const handleValidateCoupon = async (
    coupon: string
  ) => {
    return couponService.validateCoupon({coupon, association})
    .then(res => {
      return res;
    })
    .catch(_err => {
      return false;
    })
  };

  return {
    handleValidateCoupon
  }

}

export default useCoupon;